import { Link, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { Text } from "../../Primitives";
const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: 700,
        fontSize: (props) => (props.isMobile ? 22 : props.size || 28),
        lineHeight: 1.15,
        "&.condensed": {
            fontSize: 16,
            fontWeight: 600
        },
        "&:first-letter": {
            textTransform: "capitalize"
        },
        "&:hover": {
            color: theme.palette.primary.main
        }
    },
    noHover: {
        "&:hover": {
            color: theme.palette.common.black
        }
    }
}));
export const ClickableTitle = (props) => {
    const { title, titleUrl, size } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const classes = useStyles({ size, isMobile });
    return (React.createElement(Link, { href: titleUrl, underline: "none" },
        React.createElement(Text, { color: "textPrimary", className: classNames(classes.title, props.condensedTitle ? "condensed" : "") }, title)));
};
//# sourceMappingURL=ClickableTitle.js.map